import { useEffect, useState } from 'react';
import { getB2BMembershipUsage } from '../../../services/api';

const readRemainingTokens = (payload) => {
  const tokenBalance = payload?.token_balance || payload?.balance || {};
  const remaining = Number(
    tokenBalance.remaining_weighted_tokens
    ?? payload?.remaining_weighted_tokens
    ?? NaN,
  );
  return Number.isFinite(remaining) ? remaining : null;
};

export function useB2bTokenQuota() {
  const [remainingTokens, setRemainingTokens] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    getB2BMembershipUsage()
      .then((payload) => {
        if (cancelled) return;
        setRemainingTokens(readRemainingTokens(payload));
      })
      .catch(() => {
        if (!cancelled) setRemainingTokens(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    remainingTokens,
    isQuotaExceeded: remainingTokens !== null && remainingTokens <= 0,
    loading,
  };
}
